import MainLayout from "@/components/layout/admin/MainLayout.vue";
import TwspNameJson from "@/assets/json/township.json";
import RegionJson from "@/assets/json/region.json";
import {
    required,
    email,
    maxLength,
    minLength,
    numeric,
    sameAs
} from "vuelidate/lib/validators";
import axios from "axios";
import $ from "jquery";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: "companyCreate",
    components: {
        MainLayout,
        Loading
    },

    data() {
        return {
            isLoading: false,
            fullPage: true,
            id: "",
            company_name: "",
            email: "",
            password: "",
            confirm_password: "",
            address: "",
            phone_number: "",
            town: "",
            region: "",
            company_detail: "",
            agency: false,
            company_logo: "",
            submitted: false,
            error_email: "",
            regionArr: RegionJson,
            selectedTwspName: "",
            twspNameJson: TwspNameJson,
            twspName: [],
        };
    },

    validations: {
        company_logo: {
            required
        },
        company_name: {
            required,
            maxLength: maxLength(100)
        },
        email: {
            // required,
            email
        },
        password: {
            required,
            minLength: minLength(8),
            maxLength: maxLength(12)
        },
        confirm_password: {
            required,
            sameAsPassword: sameAs("password")
        },
        // address: {
        //     required
        // },
        phone_number: {
            // required,
            minLength: minLength(9),
            maxLength: maxLength(11),
            numeric
        },
        // town: {
        //     required
        // },
        region: {
            required
        },
        // company_detail: {
        //     required
        // }
    },

    methods: {
        onChange(event) {
            var Value = event.target.value;
            this.region = Value;
            this.selectedTwspName = "";
            this.twspName = this.changeTwspName(Value);
        },

        changeTwspName(value, twspName) {
            twspName = this.twspNameJson[value];
            return twspName;
        },

        onChangeTwspName(event) {
            var Value = event.target.value;
            this.town = Value;
        },

        onProfileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) return null;
            this.company_logo = e.target.files[0];
            let reader = new FileReader();
            reader.onload = e => {
                this.company_logo = e.target.result;
            };
            reader.readAsDataURL(files[0]);
        },

        submit() {
            this.submitted = true;
            if (this.$v.$invalid) {
                return;
            }
            this.companyCreate();
        },

        companyCreate() {
            $("#block-btn").attr("disabled", true);
            this.isLoading = true;
            const data = new FormData();
            if (this.company_logo.length < 10000000) {
                data.append("company_logo", this.company_logo);
            } else {
                data.append("company_logo", '');
            }

            data.append("company_name", this.company_name),
            data.append("email", this.email),
            data.append("password", this.password),
            data.append("address", this.address),
            data.append("phone_number", this.phone_number),
            data.append("town", this.town),
            data.append("region", this.region),
            data.append("company_detail", this.company_detail),
            data.append("agency", this.agency),
            // data.append("company_logo", this.company_logo);

            axios.post("/company/create", data, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
            .then(response=> {
                if (response.data.img_error_msg) {
                    $("#block-btn").attr("disabled", false);
                    this.image_size = response.data.msg;
                    this.isLoading = false;
                    this.$notification.error("The upload image size is too large.", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                } else if (response.data.msg) {
                    $("#block-btn").attr("disabled", false);
                    this.error_email = response.data.msg;
                    this.isLoading = false;
                    this.$notification.error("Company Adding Failed", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                } else {
                    this.$notification.success("Company Added Successfully", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                    this.isLoading = false;
                    this.$router.push({
                        name: "companyList"
                    });
                }
            })
            .catch(error => {
                console.log("Company Create API Error", error.errors);
            });
        }
    }
};